import { gql } from "@apollo/client";

export const FR_TASK_RESOURCE_FIELDS = gql`
    fragment fr_TaskResourceFields on TaskResource {
        TaskResourceId
        Created
        Updated
    }
`;
